export default __webpack_public_path__ + "static/media/25120417.6f51d4df.jpg";